import $ from 'jquery';


export default class SlickLightboxLayoutHelper {
	constructor(node, index, type) {
		this.options = {};
		this.node = node;
		this.index = index;
		this.type = type;
	}

	/**
	 * functions that need to be run on slick lightboxs
	 * `show` method
	 * @chainable
	 */
	onShow() {
		this.initListeners()
			.changeSlickLightboxBackgroundOnTablet()
			.appendHeaderAndFooter();
		
		// @todo put into chainable methods
		['slick-prev', 'slick-next'].map(this.removeText);

		return this;
	}

	/**
	 *
	 * @chainable
	 */
	initListeners() {
		$(window).on('WindowResizeComplete', this.changeSlickLightboxBackgroundOnTablet);
		return this;
	}

	/**
	 *
	 * @chainable
	 */
	changeSlickLightboxBackgroundOnTablet() {
		var bg = document.getElementsByClassName('slick-lightbox')[0]
		if (window.matchMedia('(min-width: 767px)').matches) {
			bg.style.background = 'rgba(0, 0, 0, 1)';
		} else {
			bg.style.background = 'rgba(255, 255, 255, 1)';	
		}
		return this;
	}

	/**
	 *
	 * @chainable
	 */
	appendHeaderAndFooter() {
		var data = this.getSlideMetaData();
		var items = Array.prototype.slice.call(document.getElementsByClassName('slick-lightbox-slick-item'));
		items = items.filter((slide) => {

			if ($(slide).hasClass('slick-cloned')) {
				return false;
			}
			return true;
		})

		items.map((slide, index) => {
			if (data[index] !== undefined) {
				if (data[index].imageTitle != '') {
					$(slide).prepend('<div class="slick-lightbox-slick-item-header"><span class="slick-item-header-title">'+data[index].imageTitle+'</span></div>');
				}
				$(slide).append('<div class="slick-lightbox-slick-item-footer"><span class="slick-item-footer-pagination">' + (data[index].index) + '/' + data[index].length + '</span><span class="slick-item-footer-caption">'+data[index].caption+'</span></div>');
				$(slide).children('.slick-lightbox-slick-item-inner').prepend('<span class="slick-item-inner-pagination">' + (data[index].index) + ' of ' + data[index].length + '</span>');

			}
		})
		return this;
	}

	/**
	 * [getSlideMetaData description]
	 * @todo  hacky
	 * @todo put captions and images cover image call into methods
	 * @return {[type]} [description]
	 */
	getSlideMetaData() {
		if (this.type === 'grid') {
			var slideshowTriggers = Array.prototype.slice.call(document.getElementsByClassName('detail-slideshow-trigger'));

			return slideshowTriggers.map((el) => {
				return {
					imageTitle: el.dataset.imageTitle,
					index: parseInt(el.dataset.index, 10),
					length: el.dataset.length,
					caption: el.dataset.caption
				};
			});

		} else {
			// put these methods into a helper class
			var images = this.node.children('.gallery-preview__cover-image').data('images').split(',');
			var captions = this.node.children('.gallery-preview__cover-image').data('captions').split('&&');
			var titles = this.node.children('.gallery-preview__cover-image').data('titles').split('&&');

			return images.map((el, index) => {
				return {
					imageTitle: titles[index],
					index: parseInt(index, 10) + 1,
					length: images.length,
					caption: captions[index]
				}
			});

		}
	}

	/**
	 * [removeText description]
	 * @param  {[type]} className [description]
	 * @chainable
	 * @return {[type]}           [description]
	 */
	removeText(className) {
		if ($('.' + className).length > 0) {
			$('.' + className).text('');
		}

		return this;
	}

	/**
	 * [leftAlignElementToElement description]
	 * @param  {[type]} elName1 [description]
	 * @param  {[type]} elName2 [description]
	 * @return {[type]}         [description]
	 */

	leftAlignElementToElement(elName1, elName2) {
		var el1 = Array.prototype.slice.call(document.getElementsByClassName(elName1));
		var el2 = Array.prototype.slice.call(document.getElementsByClassName(elName2));
		if (el1.length === 0 || el2.length === 0) {
			return false;
		}
		
		var containers = Array.prototype.slice.call(document.getElementsByClassName('slick-lightbox-slick-item-inner'));

		el2.map((value, index) => {
			if (!el1[index]) {
				return false;
			}
			return el1[index].style.transform = "translateX(" + (value.offsetLeft - containers[index].offsetLeft) + "px)";
	
		});
		return this;
	}
}